import { format, parseISO } from "date-fns";
import { Progress } from "@/components/ui/progress";

export const JourneyMembers = ({ items, classes }) => {
  if (!items.length) return <p className="rounded-2xl border border-dashed border-slate-300 bg-white p-8 text-center text-sm text-slate-400" data-testid="journey-members-empty">No members have saved their journey yet.</p>;
  const total = classes.length || 1;
  const title = (id) => classes.find((c) => c.id === id)?.title;
  return (
    <div className="space-y-2" data-testid="journey-members">
      {items.map((m) => {
        const done = m.completed.filter(title);
        const next = classes.find((c) => !done.includes(c.id));
        return (
          <div key={`${m.mobile}-${m.updated_at}`} className="grid gap-3 rounded-2xl border border-slate-200 bg-white p-4 sm:grid-cols-[1fr_220px]" data-testid={`journey-member-${m.mobile}`}>
            <div className="min-w-0">
              <p className="font-medium text-slate-900">{m.name} <span className="text-sm font-normal text-slate-500">· {m.mobile} · {m.email}</span></p>
              <p className="mt-1 text-xs text-slate-500">Finished: {done.length ? done.map(title).join(", ") : "none yet"}</p>
              <p className="text-xs text-[#1D64B4]">Next step: {next ? next.title : "Journey complete"}</p>
            </div>
            <div className="self-center">
              <div className="flex justify-between text-xs text-slate-500"><span>{done.length} of {classes.length}</span><span>Updated {format(parseISO(m.updated_at), "MMM d")}</span></div>
              <Progress value={(done.length / total) * 100} className="mt-1 h-2" />
            </div>
          </div>
        );
      })}
    </div>
  );
};
